'use es6';

import UsageTracker from 'DesignManagerIde/utils/usageTracker/usageTracker';
import { isFunction } from 'underscore';
import { getTrackPayload, usageTrackerActions } from 'usage-tracker-redux';
import { byId } from 'ContentUtils/constants/TemplateTypes';
import { CUSTOM_WIDGET, LAYOUT, TEMPLATE, CSS as FOLDER_TYPE_CSS, JS } from 'DesignData/constants/FolderAssetTypes';
import { HUBL_HTML, HUBL_CSS, HUBL_JS, HTML, CSS as TEMPLATE_FILE_TYPE_CSS, JS as TEMPLATE_FILE_TYPE_JS } from 'DesignData/constants/TemplateFileTypes';
import { TEMPLATE as DESIGN_ASSET_TYPE_TEMPLATE, CUSTOM_WIDGET as DESIGN_ASSET_TYPE_CUSTOM_WIDGET, LAYOUT as DESIGN_ASSET_TYPE_LAYOUT, GLOBAL_WIDGET, GLOBAL_GROUP } from 'DesignData/enums/DesignAssetTypes';
import FilePathScreenNames from 'DesignData/constants/FilePathScreenNames';
import TemplateBuffer from 'DesignData/models/TemplateBuffer';
const {
  track
} = usageTrackerActions;
export const CUSTOM_MODULE_EDITOR_EVENT = 'customWidgetInteraction';
export const CODED_FILE_EDITOR_EVENT = 'codedFileEvent';
export const LAYOUT_EDITOR_EVENT = 'layoutInteraction';
export const FINDER_EVENT = 'finderInteractionOnReceive';
export const UPLOAD_FILE_EVENT = 'uploadFileInteraction';
export const CHILD_THEME_EVENT = 'childThemeCreationOnReceive';
export function getFinderFileType(action) {
  const fileType = action.fileType || action.file && action.file.type;

  switch (fileType) {
    case LAYOUT:
      return 'dnd';

    case TEMPLATE:
      return 'template';

    case FOLDER_TYPE_CSS:
      return 'css';

    case JS:
      return 'js';

    case CUSTOM_WIDGET:
      return 'module';

    default:
      return typeof fileType === 'string' ? fileType : 'unknown';
  }
}
export function getCodedFileType(action) {
  if (action.template) {
    const templateBuffer = new TemplateBuffer(action.template);
    const templateFileType = templateBuffer.getFileType();

    switch (templateFileType) {
      case HUBL_HTML:
      case HTML:
        return 'html';

      case HUBL_CSS:
      case TEMPLATE_FILE_TYPE_CSS:
        return 'css';

      case HUBL_JS:
      case TEMPLATE_FILE_TYPE_JS:
        return 'js';

      default:
        break;
    }
  }

  return null;
}
export function getAssetType(assetType) {
  switch (assetType) {
    case DESIGN_ASSET_TYPE_TEMPLATE:
      return 'template';

    case DESIGN_ASSET_TYPE_CUSTOM_WIDGET:
      return 'module';

    case GLOBAL_WIDGET:
      return 'global-module';

    case DESIGN_ASSET_TYPE_LAYOUT:
      return 'drag-and-drop-template';

    case GLOBAL_GROUP:
      return 'global-group';

    default:
      return 'unknown';
  }
}
export function getDndFileCategory(action) {
  const templateType = action.layout && byId[action.layout.templateType];
  return templateType ? `dnd-${templateType.name}` : 'dnd';
}
export function getScreen(pathName) {
  // Grabs first part of pathName
  const route = pathName.split('/')[1];
  if (!route) return FilePathScreenNames['empty'];
  return FilePathScreenNames[route];
}
export function getExtraJsonForAction(actionEvent, extraJson = {}) {
  return Object.assign({
    action: actionEvent
  }, extraJson);
}
export function getEditorUsageEventPayload(editorEventType, actionEvent) {
  return getTrackPayload(editorEventType, getExtraJsonForAction(actionEvent));
}
export const getFinderActionEventPayload = (...partialArgs) => getEditorUsageEventPayload(FINDER_EVENT, ...partialArgs);
export function trackLayoutInteraction(actionEvent, extraJson = {}) {
  // If dispatch() is used, method signature will be
  // (dispatch, getState) => {}
  return (action, state, _dispatch) => {
    const dispatch = isFunction(_dispatch) ? _dispatch : action;
    return dispatch(track(LAYOUT_EDITOR_EVENT, getExtraJsonForAction(actionEvent, extraJson)));
  };
} // ********** PUBLIC EVENT **********
// Public Events help teams across HubSpot automate work and customize experiences based on user actions.
// Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
// Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation

export function trackPublish(assetType) {
  return track('publish', {
    'asset-type': assetType
  });
} // Miscellaneous events

export function trackAppLoad() {
  UsageTracker.track('appLoad');
}
export function trackOpenContextMenu() {
  UsageTracker.track('openContextMenu');
}
export function trackSidebarWidgetDnD(type) {
  return getTrackPayload('sidebarWidgetDNDInteraction', getExtraJsonForAction('added-module-from-sidebar', {
    type
  }));
}
export function trackFinderActionOnReceive(actionEvent) {
  return (action, state, dispatch) => {
    const fileType = getFinderFileType(action);

    if (fileType && action.file || action.deleted) {
      const {
        isDefault,
        path
      } = action.meta || {};
      dispatch(track(FINDER_EVENT, getExtraJsonForAction(actionEvent, {
        file_type: fileType,
        is_default: isDefault,
        path
      })));
    }
  };
}
export function trackDefaultModuleOpen(path) {
  UsageTracker.track(CUSTOM_MODULE_EDITOR_EVENT, {
    action: 'opened-default-module',
    path
  });
}